import { cn } from "@base/lib/utils";

interface SpinnerProps {
  size?: number;
  color?: string;
  className?: string;
}

export function Spinner({ size = 75, color = "#5A7EE9", className }: SpinnerProps) {
  const thickness = Math.round(size * 0.12);
  const mask = `radial-gradient(farthest-side, transparent calc(100% - ${thickness}px - 0.5px), #000 calc(100% - ${thickness}px + 0.5px))`;

  return (
    <div
      className={cn("animate-spin rounded-circle", className)}
      style={{
        width: size,
        height: size,
        background: `conic-gradient(from 180deg at 50% 50%, ${color} 0deg, rgba(255, 255, 255, 0.50) 360deg)`,
        mask,
        WebkitMask: mask,
      }}
    />
  );
}
